import { DeleteEvent, UpdateEvent } from "../../redux/events";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { ErrorBanner } from "../../components/banner";
import { EventForm } from "./EventForm";
import { IoTrash } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";

export const EventEdit = () => {
  const { error, loading } = useSelector((state) => state.events);
  const dispatch = useDispatch();
  const { state } = useLocation();
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      const address = {
        street: values.street || " ",
        city: values.city || " ",
        state: values.state || " ",
        zipcode: values.zipcode || " ",
      };

      const newValues = {
        ...values,
        description: values.description || " ",
        address,
      };

      dispatch(UpdateEvent(state.event.id, newValues));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/events");
      }, 500);
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this?`)) {
      dispatch(DeleteEvent(state.event));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/events");
      }, 500);
    }
  };

  const InitialValues = {
    ...state.event,
    street: state.event?.address?.street,
    city: state.event?.address?.city,
    state: state.event?.address?.state,
    zipcode: state.event?.address?.zipcode,
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Section>
      <SubNav>
        <li onClick={onDeleteSubmit}>
          <IoTrash />
          <Text>Delete</Text>
        </li>
      </SubNav>
      {error && <ErrorBanner text={error} />}
      <EventForm initialValues={InitialValues} onFormSubmit={onFormSubmit} />
    </Section>
  );
};

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: red;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: red;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;
